import React, { useState, ReactNode, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import { getTravels, GetTravelsForCustomerSupportResponse } from 'services/customerSupportService';

type Props = {
  render(loading: boolean, trips: GetTravelsForCustomerSupportResponse): ReactNode;
};

const PAGE_SIZE = 10;

const TripListContainer = ({ render }: Props) => {
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState<GetTravelsForCustomerSupportResponse>({
    currentPage: 0,
    hasNext: true,
    hasPrevious: false,
    pageSize: 10,
    totalCount: 0,
    totalPages: 0,
    travels: [],
  });

  const user = useSelector((state: RootState) => ({
    isLoading: state.user.isLoading,
    accountResult: state.user.accountResult,
  }));

  useEffect(() => {
    const fetch = async () => {
      if (!response.hasNext) return;
      if (user.isLoading || !user.accountResult) return;

      const { id: userId } = user.accountResult;

      const resp = await getTravels({ userId, pageNumber: response.currentPage + 1, pageSize: PAGE_SIZE });
      if (resp.succeeded) {
        setResponse((r) => ({
          ...resp.data,
          travels: resp.data && resp.data.travels ? [...r.travels, ...resp.data.travels] : [...r.travels],
        }));
      }
      setLoading(false);
    };

    fetch();
  }, [user.isLoading, user.accountResult, response.currentPage, response.hasNext]);

  return <>{render(loading, response)}</>;
};

export default TripListContainer;
